import { Typography, Box } from "@mui/material";

const textStyles = {
  fontSize: {
    xs: 'clamp(15px, 4vw, 22px)',
    sm: '22px',
    md: '28px',
  },

  lineHeight: 1.4,
  fontWeight: 400,
  fontFamily: "inherit",
};

export const aboutSections = [
  {
    key: "section1",
    image: '/images/about/section1.webp',
    content: (
      <Box>
        <Typography sx={{ ...textStyles }}>
          Built in the shadow of Covid’s long tail, our studio was created with deep
          intention — to support and uplift the remarkable creative community and small
          businesses that make this place so special.
        </Typography>
        <Typography sx={{ ...textStyles, mt: 4 }}>
          Rooted in soulful voices, stories, and legacies of resilience and great work,
          we set out to reinvigorate, amplify, and (let’s be real) spark new revenue
          streams for the wonder and talent is here.
        </Typography>
        <Typography sx={{ ...textStyles, mt: 4 }}>
          Our studio is a{" "}
          <span style={{ color: "rgb(202, 247, 111)" }}>labor of love</span> — a bridge
          between past and future, tradition and innovation — created to honor where we
          come from and help shape where we’re headed.
        </Typography>
      </Box>
    ),
  },
  {
    key: "section2",
    image: "/images/about/section2.avif",
    content: (
      <Typography sx={{ ...textStyles, lineHeight: 1.4, fontSize: "clamp(24px, 5vw, 48px)"}}>
        Supporting amplification of regional voices, bridging communities, and championing
        creative collaboration + storytelling{" "}
        <span style={{ color: "rgb(82, 82, 82)" }}>
          by bringing professional recording and design solutions to serve the level of
          storytelling and soul here.
        </span>
      </Typography>
    ),
  },
  {
    key: "section3",
    image: "/images/about/section3.avif",
    content: (
      <Typography sx={{ ...textStyles, lineHeight: 1.4, fontSize: "clamp(24px, 5vw, 48px)" }}>
        <span style={{ color: "rgb(82, 82, 82)" }}>
          The studio strives to give the South’s rich culture, diverse voices, and creative
          industries a larger stage—one that drives economic growth, supports small businesses,
          and preserves our stories for future generations
        </span>{" "}
        by developing professional audio solutions.
      </Typography>
    ),
  },
];

export const landingSection = [
  {
    key: "section1",
    content: (
      <Box>
        <Typography sx={{ ...textStyles, lineHeight: 1.4, fontSize: "clamp(24px, 5vw, 48px)"}}>
           The studio strives to give the South’s rich culture, diverse voices, and creative industries{' '}
          <span style={{ color: "rgb(82, 82, 82)" }}>
          a larger stage—one that drives economic growth, supports small businesses,
          and preserves our stories for future generations.
          </span>
        </Typography>
      </Box>
    ),
  },
  {
    key: "section2",
    content: (
      <Typography sx={{ ...textStyles, lineHeight: 1.4, fontSize: "clamp(24px, 5vw, 48px)"}}>
          <span style={{ color: "rgb(82, 82, 82)" }}>
            The studio strives to give the South’s rich culture, diverse voices, and creative industries
          </span> {' '}
          a larger stage—one that drives economic growth, supports small businesses,
          <span style={{ color: "rgb(82, 82, 82)" }}> {' '}
          and preserves our stories for future generations.
          </span>
      </Typography>
    ),
  },
  {
    key: "section3",
    content: (
      <Typography sx={{ ...textStyles, lineHeight: 1.4, fontSize: "clamp(24px, 5vw, 48px)"}}>
          <span style={{ color: "rgb(82, 82, 82)" }}>
          The studio strives to give the South’s rich culture, diverse voices, and creative industries
          a larger stage—one that drives economic growth, supports small businesses,
          </span>{' '}
          and preserves our stories for future generations.
      </Typography>
    ),
  },
];